import React, { useCallback, useMemo, useState } from "react";
import {
  BankCloseIcon,
  BankOpenIcon,
  BusinessActivitiesIcon,
  CompanyIcon,
  ExpandLess,
  LocalDirectorIcon,
  ParticularsIcon,
  RegisteredAddressIcon,
  ShareholdersIcon,
  YearEndIcon,
} from "../../assets/svg/AllSvg";
import { useNavigate } from "react-router-dom";
import Step from "./components/Step";

const stepList = {
  appointment_of_new_local_director: {
    icon: <LocalDirectorIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "Invitation to", subText: "join company" },
      { text: "Due Diligence", subText: "on new director" },
      { text: "SGCorpHub Processing", subText: "if Documents" },
      { text: "ACRA", subText: "Filing", logo: true },
    ],
  },
  appointment_of_new_foreign_director: {
    icon: <LocalDirectorIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "Invitation to", subText: "join company" },
      { text: "Due Diligence", subText: "on new director" },
      { text: "SGCorpHub Processing", subText: "if Documents", logo: true },
      { text: "ACRA", subText: "Filing", logo: true },
    ],
  },
  appointment_of_new_executive_director: {
    icon: <LocalDirectorIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "Invitation to", subText: "join company" },
      { text: "Due Diligence", subText: "on new director" },
    ],
  },
  nominee_director: [],
  open_bank_account: {
    icon: <BankOpenIcon />,
    step: [
      { text: "Bank", subText: "Selection" },
      { text: "Acknowledge", subText: "requirements" },
      { text: "Head down", subText: "to the bank" },
    ],
  },
  close_bank_account: {
    icon: <BankCloseIcon />,
    step: [
      { text: "Bank", subText: "Selection" },
      { text: "Acknowledge", subText: "requirements" },
      { text: "Head down", subText: "to the bank" },
    ],
  },
  change_of_company_name: {
    icon: <CompanyIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "SGCorpHub Processing", subText: "Documents", logo: true },
      { text: "Pending your", subText: "Signatures", logo: true },
      { text: "ACRA", subText: "Filing", logo: true },
    ],
  },
  change_of_business_activities: {
    icon: <BusinessActivitiesIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "Process", subText: "required information", logo: true },
      { text: "Pending your", subText: "Signatures", logo: true },
      { text: "ACRA", subText: "Filing", logo: true },
    ],
  },
  change_of_company_registered_address: {
    icon: <RegisteredAddressIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "SGCorpHub Processing", subText: "Documents", logo: true },
      { text: "Pending your", subText: "Signatures", logo: true },
      { text: "ACRA", subText: "Filing", logo: true },
    ],
  },
  change_of_directors_particulars: {
    icon: <ParticularsIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "Process", subText: "required document", logo: true },
      { text: "Pending your", subText: "Signatures", logo: true },
      { text: "ACRA", subText: "Filing", logo: true },
    ],
  },
  change_of_shareholders_particulars: {
    icon: <ShareholdersIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "Process", subText: "required document", logo: true },
      { text: "Pending your", subText: "Signatures", logo: true },
      { text: "ACRA", subText: "Filing", logo: true },
    ],
  },
  change_of_financial_year_end: {
    icon: <YearEndIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "Process", subText: "information", logo: true },
      { text: "Pending your", subText: "Signatures", logo: true },
      { text: "ACRA", subText: "Filing", logo: true },
    ],
  },
  allotment_transfer_of_shares: {
    icon: <ShareholdersIcon />,
    step: [
      { text: "Add shareholders", subText: "if any" },
      { text: "Configure", subText: "Cap Table" },
      { text: "Payment", subText: "if upgrade required " },
      { text: "Invite to", subText: "join company" },
      { text: "Due Diligence", subText: "on new shareholder if have" },
      {
        text: "SGCorpHub Processing",
        subText: "Processing documents for signatures",
        logo: true,
      },
    ],
  },
  applying_pass: {
    icon: <YearEndIcon />,
    step: [
      { text: "Payment", subText: "if required" },
      { text: "Process", subText: "information", logo: true },
      { text: "Pending", subText: "documents", logo: true },
      { text: "MOM", subText: "Submission", logo: true },
    ],
  },
};

const Services = ({ element }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const user_Id = sessionStorage.getItem("user_Id");
  const getCompanyID = sessionStorage.getItem("companyID");

  const toggleOpen = useCallback(() => setIsOpen((prev) => !prev), []);

  const steps = useMemo(() => stepList[element?.slug]?.step, [element?.slug]);
  const icon = useMemo(() => stepList[element?.slug]?.icon, [element?.slug]);

  const renderServiceDetails = useCallback(
    (details, element) => (
      <div className="grid lg:grid-cols-3 items-center border-b px-6 py-4">
        <div className="col-span-2 lg:border-r border-0">
          <div className="flex space-x-4 mb-3">
            <div className="pr-4 border-r-2 border-secondary_grey">
              <p className="sm:text-sm text-xs text-gray-400 mb-1">
                Filling of Form:
              </p>
              <p className="text-theme sm:text-base text-sm">
                {details?.formTime}
              </p>
            </div>
            <div className="pr-4 border-r-2 border-secondary_grey sm:text-sm text-xs">
              <p className="text-sm text-gray-400 mb-1">Processing Time:</p>
              <p className="text-theme sm:text-base text-sm">
                {element?.detail?.duration
                  ? element?.detail?.duration
                  : details?.processingTime}
              </p>
            </div>
            <div>
              <p className="text-gray-400 mb-1 sm:text-sm text-xs">Price:</p>
              <p className="text-theme sm:text-base text-sm">
                Free ({element?.service_requests_count ?? 0}/
                {element?.detail?.no_of_free_request ?? 0})
              </p>
            </div>
          </div>
          {details?.requirements?.length ? (
            <div className="sm:text-sm text-xs">
              <p className="mb-1">What will you need?</p>
              {details?.requirements?.map((req, idx) => (
                <p key={idx}>{req}</p>
              ))}
            </div>
          ) : null}
        </div>
        <div className="lg:pl-5 lg:mt-0 text-center mt-3">
          <button
            className="btn-theme"
            onClick={() =>
              navigate(details?.navigateTo, {
                state: {
                  user_id: user_Id,
                  company_id: getCompanyID,
                  service: element,
                },
              })
            }
          >
            Create A Service request
          </button>
        </div>
      </div>
    ),
    [navigate, user_Id, getCompanyID]
  );

  const serviceDetails = useMemo(() => {
    switch (element?.slug) {
      case "appointment_of_new_local_director":
        return {
          formTime: "< 15 mins",
          processingTime: "4 to 5 working days",
          price: "Free (0/3)",
          requirements: [
            "Create a request for a new director joining your company",
          ],
          navigateTo: "/local-director",
        };
      case "appointment_of_new_foreign_director":
        return {
          formTime: "< 15 mins",
          processingTime: "4 to 5 working days",
          requirements: [
            "Create a request for a new director joining your company",
          ],
          navigateTo: "/foreign-director",
        };
      case "open_bank_account":
      case "close_bank_account":
        return {
          formTime: "< 5 mins",
          processingTime: "Instant",
          requirements: [],
          navigateTo:
            element?.slug === "open_bank_account"
              ? "/open-bank-account"
              : "/close-bank-account",
        };
      case "change_of_directors_particulars":
        return {
          formTime: "< 5 mins",
          processingTime: "4 to 5 working days",
          requirements: ["- An updated address", "- Signing of documents"],
          navigateTo: "/change-director-particular",
        };
      case "change_of_company_registered_address":
        return {
          formTime: "< 5 mins",
          processingTime: "4 to 5 working days",
          requirements: ["- The updated particulars"],
          navigateTo: "/change-company-address",
        };
      case "change_of_business_activities":
        return {
          formTime: "< 5 mins",
          processingTime: "4 to 5 working days",
          requirements: [
            "- Descriptions of activities must be limited to 75 words.",
          ],
          navigateTo: "/change-business-activity",
        };
      case "change_of_company_name":
        return {
          formTime: "< 15 mins",
          processingTime: "5 - 2 months working days (for referred cases",
          requirements: [
            "- All suggested new names will undergo availability checks with ACRA.",
            "- ACRA imposes a $15 fee for name reservation, which SGCorpHub has graciously got you covered.",
          ],
          navigateTo: "/change-company-name",
        };
      case "applying_pass":
        return {
          formTime: "< 15 mins",
          processingTime: "5 - 2 months working days (for referred cases",
          requirements: [
            "- All suggested new names will undergo availability checks with ACRA.",
          ],
          navigateTo: "/applying-passes",
        };
      case "change_of_shareholders_particulars":
        return {
          formTime: "< 5 mins",
          processingTime: "4 to 5 working days",
          requirements: ["- The updated particulars"],
          navigateTo: "/change-shareholder-particular",
        };
      case "change_of_financial_year_end":
        return {
          formTime: "< 5 mins",
          processingTime: "4 to 5 working days",
          requirements: ["- Your ideal Financial Year End period"],
          navigateTo: "/change-financial-year-end",
        };
      case "allotment_transfer_of_shares":
        return {
          formTime: "< 15 mins",
          processingTime: "3 to 4 working days",
          price: "Conditional",
          requirements: [
            "- Details of new shareholders (if applicable)",
            "- Revised shareholding structure",
            "- Proof of remittance, recent financial statements/management accounts, or a contract  . drafted by a lawyer",
          ],
          navigateTo: "/allotment-transfer-new-shareholder",
        };
      // Add other cases as needed
      default:
        return null;
    }
  }, [element?.slug]);

  return (
    <div className="hover:bg-light_secondary_shades">
      <div
        className="cursor-pointer flex justify-between items-start border-b px-6 py-4"
        onClick={toggleOpen}
      >
        <div className="flex items-center space-x-5">
          <div className="min-w-9">{icon}</div>
          <div>
            <p className="lg:text-2xl md:text-xl sm:text-base font-ebGaramond text-theme mb-2">
              {element?.service_name}
            </p>
            <p className="sm:text-base text-xs">{element?.remarks}</p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <p className="text-theme border-b inline-block sm:text-base text-xs">
            {isOpen ? "Minimize" : "View"}
          </p>
          {isOpen ? <ExpandLess /> : <ExpandLess className="rotate-180" />}
        </div>
      </div>
      {isOpen && (
        <>
          <div
            className={`flex space-x-20 border-sp max-w-full overflow-auto px-4 ${
              steps?.length && "mt-5"
            }`}
          >
            {steps?.map((step, idx) => (
              <Step key={idx} step={step} />
            ))}
          </div>
          {serviceDetails && renderServiceDetails(serviceDetails, element)}
        </>
      )}
    </div>
  );
};

export default Services;
